<template>
  <el-form class="ui-searchbar" status-icon :model="opt" ref="searchbar">
    <el-form-item class="">
      <el-input
        :placeholder="opt.placeholder"
        v-model.trim="opt.text"
        :clearable="true"
        class="input-with-select"
        @keyup.enter.native="query"
      >
        <el-select
          v-model="opt.filter.value"
          slot="prepend"
          v-if="opt.filter.show"
          @change="query"
        >
          <el-option
            v-for="item in opt.filter.filterList"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button
          class="btn-search btn-gray"
          slot="append"
          icon="el-icon-search"
          @click="query"
        ></el-button>
      </el-input>
    </el-form-item>
  </el-form>
</template>
<script>
import { isNotNullORBlank, getQueryStr } from "../../utils/utils";
export default {
  name: "searchbar",
  data() {
    return {};
  },
  props: {
    opt: {
      type: Object,
      default: () => {
        return {
          placeholder: "",
          text: "",
          filter: {
            show: false,
            value: "",
            filterList: []
          }
        };
      }
    }
  },
  methods: {
    query() {
      this.$emit("query", {
        text: this.opt.text,
        filter: this.opt.filter.value
      });
    }
  }
};
</script>
<style>
.ui-searchbar .el-select .el-input {
  width: 200px;
}

.ui-searchbar .el-input-group__prepend {
  background-color: #fff;
  /*border-color: #bfbfbf*/
}

.ui-searchbar .el-input-group__append {
  background-color: #ccc;
  color: #666;
  /*border-color: #bfbfbf*/
  border: 1px solid #ccc;
}

.ui-searchbar .el-input-group__append:hover,
.ui-searchbar .el-input-group__append:active {
  background-color: #a50606;
  color: #fff;
  border: 1px solid #a50606;
}

.ui-searchbar .el-input-group__prepend {
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
}

.ui-searchbar .el-input__inner:first-child {
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
}

.ui-searchbar .el-input-group__append {
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  overflow: hidden;
}
</style>
<style scoped>
.ui-searchbar {
  /* padding: 20px 20px 0; */
  background: white;
  overflow: hidden;
}
.btn-search {
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
}
</style>